/**
 * ELORE Homepage Section — behaviour
 * Extracted verbatim (logic-for-logic) from the original inline <script> block
 * plus the inline onclick/onmouseover handlers that lived on individual
 * elements. Nothing here changes behaviour — it only moves it out of markup
 * and into an external, CSP-friendly asset.
 *
 * All logic is namespaced under EloreHomepage and (re)initialised on
 * DOMContentLoaded, and also on Shopify theme editor section load/reorder
 * events, so the section keeps working when merchants edit it live.
 */
(function () {
  "use strict";

  function initHeroCarousel(root) {
  var slides = root.querySelectorAll("#hero-carousel-container .slide");
  var dots = root.querySelectorAll(".hero-dot");

  if (!slides.length) return function () {};

  var currentSlide = 0;
  var slideCount = slides.length;

  var slideInterval = 2500;
  var brandSlideIndex = 4;
  var brandSlideDuration = 3500;

  var timeoutId = null;
  var destroyed = false;

  function updateDots() {
    dots.forEach(function (dot, index) {
      if (index === currentSlide) {
        dot.classList.remove("w-2", "bg-white/50");
        dot.classList.add("w-8", "bg-white");
      } else {
        dot.classList.remove("w-8", "bg-white");
        dot.classList.add("w-2", "bg-white/50");
      }
    });
  }

  function showSlide(index) {
    slides.forEach(function (slide, slideIndex) {
      var image = slide.querySelector(".parallax-bg");
      var text = slide.querySelector(".slide-text");

      if (slideIndex === index) {
        slide.classList.add("active");

        if (image) {
          image.style.transform = "scale(1.04)";
        }

        if (text) {
          text.style.opacity = "1";
          text.style.transform = "translateY(0)";
        }
      } else {
        slide.classList.remove("active");

        if (image) {
          image.style.transform = "scale(1.08)";
        }

        if (text) {
          text.style.opacity = "0";
          text.style.transform = "translateY(20px)";
        }
      }
    });

    updateDots();
  }

  function nextSlide() {
    if (destroyed) return;

    currentSlide = (currentSlide + 1) % slideCount;

    showSlide(currentSlide);

    var delay =
      currentSlide === brandSlideIndex
        ? brandSlideDuration
        : slideInterval;

    timeoutId = setTimeout(nextSlide, delay);
  }

  showSlide(0);

  timeoutId = setTimeout(nextSlide, slideInterval);

  return function destroy() {
    destroyed = true;

    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
}

  function initHeaderScrollEffect(root) {
    var header = root.querySelector("#top-nav");
    if (!header) return function () {};

    function onScroll() {
      if (window.scrollY > 50) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    }

    window.addEventListener("scroll", onScroll);
    return function destroy() {
      window.removeEventListener("scroll", onScroll);
    };
  }

  function initBottomNav(root) {
    var bottomNav = root.querySelector("#bottom-nav");
    var heroSection = root.querySelector("#hero-section");
    if (!bottomNav || !heroSection) return function () {};

    var lastScrollY = window.scrollY;
    var heroInView = true;

    // IntersectionObserver to detect when Hero is in view
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          heroInView = entry.isIntersecting;
          if (heroInView) {
            bottomNav.classList.remove("show");
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(heroSection);

    // Scroll direction detection
    function onScroll() {
      var currentScrollY = window.scrollY;

      if (!heroInView) {
        if (currentScrollY < lastScrollY) {
          // Scrolling Up
          bottomNav.classList.add("show");
        } else {
          // Scrolling Down
          bottomNav.classList.remove("show");
        }
      }

      lastScrollY = currentScrollY;
    }

    window.addEventListener("scroll", onScroll, { passive: true });

    return function destroy() {
      window.removeEventListener("scroll", onScroll);
      observer.disconnect();
    };
  }

  // Was: onclick="this.querySelector('span').classList.toggle('fill-1'); ..."
  // on the four product-card wishlist/favorite buttons.
  function initFavoriteToggles(root) {
    var buttons = root.querySelectorAll("[data-elore-favorite-toggle]");
    var handlers = [];

    buttons.forEach(function (button) {
      function handler() {
        var icon = button.querySelector("span");
        if (icon) icon.classList.toggle("fill-1");
      }
      button.addEventListener("click", handler);
      handlers.push({ button: button, handler: handler });
    });

    return function destroy() {
      handlers.forEach(function (h) {
        h.button.removeEventListener("click", h.handler);
      });
    };
  }

  // Was: onmouseover="this.classList.remove('opacity-0', 'translate-y-8')"
  // on the "Journey Within" story section.
  function initRevealOnHover(root) {
    var sections = root.querySelectorAll("[data-elore-reveal-on-hover]");
    var handlers = [];

    sections.forEach(function (section) {
      function handler() {
        section.classList.remove("opacity-0", "translate-y-8");
      }
      section.addEventListener("mouseover", handler);
      handlers.push({ section: section, handler: handler });
    });

    return function destroy() {
      handlers.forEach(function (h) {
        h.section.removeEventListener("mouseover", h.handler);
      });
    };
  }

  // Was: onclick="window.scrollTo({top: 0, behavior: 'smooth'})"
  // on the bottom-nav "Home" button.
  function initScrollTopButtons(root) {
    var buttons = root.querySelectorAll("[data-elore-scroll-top]");
    var handlers = [];

    buttons.forEach(function (button) {
      function handler() {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      button.addEventListener("click", handler);
      handlers.push({ button: button, handler: handler });
    });

    return function destroy() {
      handlers.forEach(function (h) {
        h.button.removeEventListener("click", h.handler);
      });
    };
  }

  // Placeholder hook for the header hamburger menu button
  // (data-elore-menu-toggle). No menu drawer exists in the source markup —
  // this is left as a no-op stub so a theme's global nav drawer can be
  // wired in without touching this file's structure.
  function initCartNavigation(root) {
  var buttons = root.querySelectorAll("[data-elore-cart-link]");
  var handlers = [];

  buttons.forEach(function (button) {
    function handler(event) {
      event.preventDefault();
      event.stopPropagation();

      window.location.href = button.getAttribute("href");
    }

    button.addEventListener("click", handler);
    handlers.push({
      button: button,
      handler: handler
    });
  });

  return function destroy() {
    handlers.forEach(function (item) {
      item.button.removeEventListener("click", item.handler);
    });
  };
}

  function initSection(root) {
    var teardowns = [
      initHeroCarousel(root),
      initBottomNav(root),
      initFavoriteToggles(root),
      initRevealOnHover(root),
      initScrollTopButtons(root),
      initCartNavigation(root),
    ];

    root._eloreTeardown = function () {
      teardowns.forEach(function (fn) {
        if (typeof fn === "function") fn();
      });
    };
  }

  function destroySection(root) {
    if (root && typeof root._eloreTeardown === "function") {
      root._eloreTeardown();
      root._eloreTeardown = null;
    }
  }

  function boot() {
    document.querySelectorAll("[data-elore-homepage]").forEach(function (root) {
      initSection(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Shopify theme editor support: re-init on section load, tear down on
  // unload/deselect so listeners/observers/timers don't leak or double-fire
  // while a merchant is editing this section.
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector("[data-elore-homepage]")
      : null;
    if (root) initSection(root);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector("[data-elore-homepage]")
      : null;
    if (root) destroySection(root);
  });
})();
